import { render, staticRenderFns } from "./BackTab.vue?vue&type=template&id=69db0b36&scoped=true"
import script from "./BackTab.vue?vue&type=script&lang=js"
export * from "./BackTab.vue?vue&type=script&lang=js"
import style0 from "./BackTab.vue?vue&type=style&index=0&id=69db0b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69db0b36",
  null
  
)

export default component.exports